<!-- Hero Section  -->
<section class="ytb-v2-hero-area">
  <div class="container">
    <div class="ytb-v2-hero-content">
      <div class="ytb-v2-hero-form-wrapper">
        <ul class="nav nav-tabs ytb-v2-main-tab-list" id="myTab" role="tablist">
          <li class="nav-item tabs-item" role="presentation">
            <a
              #flight
              (click)="navigateTabs('flight')"
              class="nav-link tabs-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              <i class="mx-auto"></i> Flights
            </a>
          </li>
          <!-- <li class="nav-item tabs-item" role="presentation">
                <a  #activites (click)="navigateTabs('activities')"  class="nav-link tabs-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" 
                  role="tab" aria-controls="home" aria-selected="true">
                  <i  class="mx-auto"></i>
                  Activity
            </a>
              </li> -->
        </ul>

        <!-- MAIN TAB CONTENT -->
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <!-- Load Hotel Search Input -->
            <ng-template #hotelcontainer></ng-template>

            <!-- Load Flight Search Input -->
            <ng-template #flightcontainer></ng-template>

            <!-- Load Car Search Input -->
            <ng-template #carcontainer></ng-template>

            <!-- Load Activities Search Input -->
            <ng-template #activitycontainer></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="ytb-v2-popular-destination">
    <div class="container">
        <div class="ytb-v2-pop-destination-title">
            <h2>Popular Destinations</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 gy-3" *ngFor="let destination of dstArr; let i = index">
                <ng-container *ngFor="let dst of destination">
                    <div class="ytb-v2-single-destination" (click)="navigateToLp(dst, dst.module_Type)">
                        <img src={{dst?.destination_Image_URL}} alt="">
                        <div class="ytb-v2-destination-overlay">
                            <div class="ytb-v2-destination">
                                <h2> <a (click)="navigateToLp(dst, dst.module_Type)">{{ dst?.destination_Name }}</a> </h2>
                                <h2> {{dst?.source_code}} = {{dst?.destination_Code}}</h2>


                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>


        </div>
    </div>
</section> -->

<ng-container *ngIf="!destinationsLoader()">
  <section
    id="top-destination"
    *ngIf="dstArr()?.length > 0"
    class="ytb-v2-popular-destination"
  >
    <div class="container">
      <div class="ytb-v2-pop-destination-title">
        <h2>Popular Destinations</h2>
      </div>

      <!-- <nav>
                            <div class="nav t_nav-tabs nav-fill" id="nav-tab" role="tablist">
                                <a *ngFor="let dst of destinationType; let i = index" [ngClass]="setTabClass(i)" id="nav-destination-tab" data-toggle="tab" href="#nav-destination" role="tab" aria-controls="nav-destination" aria-selected="false" (click)="getDestinationsByType(dst)">
                                    {{ dst }}</a>
                            </div>
                        </nav> -->

      <div class="tab-content" id="nav-tabContent">
        <div
          class="tab-pane show active"
          id="nav-cities"
          role="tabpanel"
          aria-labelledby="nav-cities-tab"
        >
          <div
            id="blogCarousel"
            class="carousel slide"
            data-ride="carousel"
            data-interval="false"
          >
            <div class="carousel-inner">
              <div
                [ngClass]="setGalleryClass(i)"
                *ngFor="let destination of dstArr(); let i = index"
              >
                <div class="pad-15 row">
                  <div class="col-md-4" *ngFor="let dst of destination">
                    <!-- <div class="top-des-cb">
                                                        <a (click)="navigateToLp(dst, dst.module_Type)">
                                                            <img src={{changeFileTypeToJpg(dst.destination_Image_URL)}} onerror="this.src='assets/images/default-destination-img2.jpg'" class="lazyload img-responsive" width="300" height="100">
                                                        </a>
                                                        <div class="pad-10">
                                                            <h5 class="tp-dwn-scrlng-smhed text-center" (click)="navigateToLp(dst, dst.module_Type)">
                                                                {{ dst?.destination_Name }}
                                                            </h5>
                                                        </div>
                                                    </div> -->
                    <div
                      class="ytb-v2-single-destination"
                      (click)="navigateToLp(dst, dst.module_Type)"
                    >
                      <img src="{{ dst?.destination_Image_URL }}" alt="" />
                      <div class="ytb-v2-destination-overlay">
                        <div class="ytb-v2-destination">
                          <h2>
                            <a (click)="navigateToLp(dst, dst.module_Type)">{{
                              dst?.destination_Name
                            }}</a>
                          </h2>
                          <h2>
                            {{ dst?.source_code }} = {{ dst?.destination_Code }}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tp-dwn-scrlng-arrw">
              <a
                class="carousel-control-prev"
                href="#blogCarousel"
                role="button"
                data-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
              </a>
              <a
                class="carousel-control-next text-faded"
                href="#blogCarousel"
                role="button"
                data-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<section class="ytb-v2-main-choose-area">
  <div class="container">
    <div class="ytb-v2-choose-top">
      <h2>Why Choose Us</h2>
      <p>
        We offer most competitive rates and offers for wonderful and beautiful
        places.
      </p>
    </div>
    <div class="ytb-v2-choose-grid-area">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <div class="ytb-v2-single-choose">
            <img
              src="assets/ytb-images/footer-images/feature-1.png"
              class="card-img-top w-25 mx-auto icon-one"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title text-center">Unique Destinations</h5>
              <p class="card-text text-center text-secondary">
                Embark on a journey beyond the ordinary; discover our collection of unique destinations that promise to turn your travel dreams into extraordinary memories.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="ytb-v2-single-choose">
            <img
              src="assets/ytb-images/footer-images/feature-2.png"
              class="card-img-top w-25 mx-auto img-fluid icon-two"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title text-center">Worth of Money</h5>
              <p class="card-text text-center text-secondary">
                Get more than you imagined for every penny spent! Our travel deals are crafted to ensure that every adventure is not just enriching but also an unbeatable worth of money.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="ytb-v2-single-choose">
            <img
              src="assets/ytb-images/footer-images/feature-3.png"
              class="card-img-top w-25 img-fluid mx-auto icon-three"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title text-center">Wonderful Places</h5>
              <p class="card-text text-center text-secondary">
                From hidden gems to iconic landmarks, explore the world's most wonderful places effortlessly with our curated selection of awe-inspiring destinations that will leave you breathless.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="ytb-v2-single-choose">
            <img
              src="assets/ytb-images/footer-images/feature-4.png"
              class="card-img-top w-25 mx-auto icon-four"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title text-center">Quick Booking</h5>
              <p class="card-text text-center text-secondary">
                Your adventure begins now! Experience the fastest and easiest booking process in the travel industry – because we believe in turning your impulsive wanderlust into instant getaways.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="ytb-v2-single-choose">
            <img
              src="assets/ytb-images/footer-images/feature-5.png"
              class="card-img-top w-25 mx-auto img-fluid icon-five"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title text-center">Exciting Travel</h5>
              <p class="card-text text-center text-secondary">
                 Ignite your passion for adventure with our exciting travel options! Dive into a world where every journey is an exhilarating experience, promising to unleash the thrill-seeker in you.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="ytb-v2-single-choose">
            <img
              src="assets/ytb-images/footer-images/feature-6.png"
              class="card-img-top w-25 img-fluid mx-auto icon-six"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title text-center">Seamless Itineraries</h5>
              <p class="card-text text-center text-secondary">
                Leave the hassle behind! Our seamless itineraries take care of every detail, ensuring your journey unfolds with the perfect blend of excitement and tranquility.

              </p>
            </div>
          </div>
        </div>

        
        <div class="col-md-6 col-lg-4">
            <div class="ytb-v2-single-choose">
              <img
                src="assets/ytb-images/footer-images/feature-6.png"
                class="card-img-top w-25 img-fluid mx-auto icon-six"
                alt="..."
              />
              <div class="card-body">
                <h5 class="card-title text-center">Best Price Guarantee</h5>
                <p class="card-text text-center text-secondary">
                    Uncover unbeatable deals! With our best price guarantee, rest assured that you're getting the most competitive rates for flights, hotels, and packages, making your dream vacation even more enticing.
                </p>
              </div>
            </div>
          </div>


          
        <div class="col-md-6 col-lg-4">
            <div class="ytb-v2-single-choose">
              <img
                src="assets/ytb-images/footer-images/feature-6.png"
                class="card-img-top w-25 img-fluid mx-auto icon-six"
                alt="..."
              />
              <div class="card-body">
                <h5 class="card-title text-center">Personalized Travel Experiences</h5>
                <p class="card-text text-center text-secondary">
                    Tailor your adventure to perfection! Enjoy personalized travel experiences that cater to your unique preferences, ensuring every moment is crafted just the way you envisioned.
                </p>
              </div>
            </div>
          </div>


          
        <div class="col-md-6 col-lg-4">
            <div class="ytb-v2-single-choose">
              <img
                src="assets/ytb-images/footer-images/feature-6.png"
                class="card-img-top w-25 img-fluid mx-auto icon-six"
                alt="..."
              />
              <div class="card-body">
                <h5 class="card-title text-center">Exclusive Insider Access</h5>
                <p class="card-text text-center text-secondary">
                    Unlock hidden treasures! Gain exclusive insider access to curated experiences and off-the-beaten-path discoveries, creating memories that set your journey apart from the ordinary.
                </p>
              </div>
            </div>
          </div>

          
        <div class="col-md-6 col-lg-4">
            <div class="ytb-v2-single-choose">
              <img
                src="assets/ytb-images/footer-images/feature-6.png"
                class="card-img-top w-25 img-fluid mx-auto icon-six"
                alt="..."
              />
              <div class="card-body">
                <h5 class="card-title text-center">24/7 Global Support</h5>
                <p class="card-text text-center text-secondary">
                    Travel with confidence! Our dedicated 24/7 global support team is always at your service, ready to assist you with any questions or concerns, ensuring a worry-free and enjoyable travel experience.
                </p>
              </div>
            </div>
          </div>


          
        <div class="col-md-6 col-lg-4">
            <div class="ytb-v2-single-choose">
              <img
                src="assets/ytb-images/footer-images/feature-6.png"
                class="card-img-top w-25 img-fluid mx-auto icon-six"
                alt="..."
              />
              <div class="card-body">
                <h5 class="card-title text-center">Group Travel Made Easy</h5>
                <p class="card-text text-center text-secondary">
                    Rally your travel tribe! Experience the joy of group travel with our hassle-free coordination and exclusive group discounts, turning your shared adventures into unforgettable bonding experiences.

                </p>
              </div>
            </div>
          </div>


          
        <div class="col-md-6 col-lg-4">
            <div class="ytb-v2-single-choose">
              <img
                src="assets/ytb-images/footer-images/feature-6.png"
                class="card-img-top w-25 img-fluid mx-auto icon-six"
                alt="..."
              />
              <div class="card-body">
                <h5 class="card-title text-center">Last-Minute Getaways</h5>
                <p class="card-text text-center text-secondary">
                    Spontaneity at its best! Discover and book irresistible last-minute getaways, ensuring that every impulse to explore is met with exciting opportunities, even on short notice.
                </p>
              </div>
            </div>
          </div>




      </div>
    </div>
  </div>
</section>

<!-- Our Partner Setion -->
<section class="ytb-v2-our-partner-section">
  <div class="container">
   
    <div class="ytb-v2-partner-content">
      <h2>Our Partners</h2>
      <div class="col-inner text-justify">

      <p> Our carefully curated network allows us to offer you a diverse array of options, ensuring your travel preferences are met with unparalleled choices. These collaborations extend beyond mere transactions; they embody a shared dedication to elevating your adventures and creating memories that last a lifetime.</p>
      </div>
      <ul>
        <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-1.webp"
            alt=""
          />
        </li>
        <!-- <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-2.webp"
            alt=""
          />
        </li>
        <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-3.webp"
            alt=""
          />
        </li> -->
        <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-4.webp"
            alt=""
          />
        </li>
        <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-5.webp"
            alt=""
          />
        </li>
        <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-6.webp"
            alt=""
          />
        </li>
        <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-7.webp"
            alt=""
          />
        </li>
        <!-- <li>
          <img
            src="assets/ytb-images/footer-images/partners/partner-8.webp"
            alt=""
          />
        </li> -->
      </ul>
    </div>
  </div>
</section>
<ng-container *ngIf="destinationsLoader()">
  <div class="container col-12 col-lg-8 col-md-8">
    <h4 class="tp-dwn-scrlng-hed">Popular Destinations</h4>
    <div class="content-wrapper">
      <div class="slick-gallery-slideshow row mt-3" id="gallery">
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '25px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '25px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '25px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '25px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="dealsLoader()">
  <div class="container col-md-8">
    <span class="tp-dwn-scrlng-hed mt-2">Deals</span>
    <div class="content-wrapper">
      <div class="slick-gallery-slideshow row mt-3" id="gallery">
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '20px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '20px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '20px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="col-md-3 pad-res-tbs">
          <div class="box-title">
            <ngx-skeleton-loader
              [theme]="{
                'border-radius': '0',
                height: '250px',
                width: '100%'
              }"
            >
            </ngx-skeleton-loader>
          </div>
          <div class="box-content">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '100%',
                'border-radius': '0',
                height: '20px',
                'margin-bottom': '10px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- end Main Wrapper -->
